import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Loader2, Mail, BellRing, CalendarCheck } from "lucide-react";

const MSG = {
  enrollment_email: ["Aviso por cada inscripción activado", "Aviso por cada inscripción desactivado"],
  daily_digest: ["Resumen diario activado", "Resumen diario desactivado"],
};

const SettingRow = ({ id, icon: Icon, title, text, checked, onChange }) => (
  <label className="flex items-center justify-between gap-4 rounded-xl border p-4 cursor-pointer" data-testid={`setting-${id}-row`}>
    <span className="flex items-start gap-3">
      <Icon className="w-5 h-5 text-primary mt-0.5 shrink-0" />
      <span>
        <span className="block font-semibold text-sm">{title}</span>
        <span className="block text-xs text-muted-foreground">{text}</span>
      </span>
    </span>
    <Switch checked={!!checked} onCheckedChange={onChange} data-testid={`setting-${id}`} />
  </label>
);

export function MaestroSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/business/settings/notifications").then((r) => setS(r.data)).catch(() => setS({ enrollment_email: true })); }, []);
  const toggle = async (key, value) => {
    const prev = s;
    setS({ ...s, [key]: value });
    try {
      await api.put("/business/settings/notifications", { [key]: value });
      toast.success(MSG[key][value ? 0 : 1]);
    } catch (e) { setS(prev); toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  if (!s) return <div className="p-8 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  return (
    <Card className="p-5 max-w-2xl space-y-4" data-testid="maestro-settings">
      <div>
        <h3 className="font-bold flex items-center gap-2"><BellRing className="w-5 h-5 text-primary" />Avisos de inscripción</h3>
        <p className="text-xs text-muted-foreground mt-1">Elige cómo quieres enterarte cada vez que un alumno paga y se inscribe en uno de tus talleres.</p>
      </div>
      <SettingRow id="enrollment-email" icon={Mail} title="Correo por cada inscripción" checked={s.enrollment_email}
        text="Te enviamos un correo con el nombre del alumno, el taller, los cupos, el monto pagado y la fecha de inicio."
        onChange={(v) => toggle("enrollment_email", v)} />
      <SettingRow id="daily-digest" icon={CalendarCheck} title="Resumen diario" checked={s.daily_digest}
        text="Un solo correo a las 20:00 hrs con todas las inscripciones del día. Si no hubo inscripciones, no te enviamos nada."
        onChange={(v) => toggle("daily_digest", v)} />
      <p className="text-xs text-muted-foreground">Puedes activar una opción, la otra o ambas.</p>
    </Card>
  );
}
